/**
 * Oturumu olmayan kullanici bir derin linkle (ör. mail'deki "Talebi
 * Goruntule" -> /meeting-requests) geldiginde login ekranina dusuyor; giris
 * sonrasi her zaman /home'a gidildigi icin acmak istedigi sayfa kayboluyordu.
 *
 * Hedef adres sessionStorage'da tutulur: yalnizca o sekmeye ait olur ve
 * sekme kapaninca kendiliginden silinir.
 */
const STORAGE_KEY = 'postLoginRedirect';

const IGNORED_PATHS = new Set(['/', '/home', '/login']);

function isSafeInternalPath(path: string | null | undefined): path is string {
  if (!path || !path.startsWith('/')) return false;
  // `//evil.com` protokolsuz harici adrestir; acik yonlendirmeye izin verme.
  if (path.startsWith('//')) return false;
  const pathname = path.split(/[?#]/)[0];
  return !IGNORED_PATHS.has(pathname);
}

export function rememberPostLoginRedirect(path: string) {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Depolama kapaliysa (gizli mod vb.) varsayilan yonlendirme kullanilir.
  }
}

/** Kayitli hedefi bir kez dondurur ve siler; yoksa `fallback`. */
export function consumePostLoginRedirect(fallback: string): string {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isSafeInternalPath(stored) ? stored : fallback;
  } catch {
    return fallback;
  }
}
